const icon = new URL('../../icons/decal.png', import.meta.url).href

export default {
  type: 'decal',
  description: 'flat surface decal (3D-only) — floor zone paint, path lanes, signage',
  group: ['etc'],
  icon,
  model: {
    type: 'decal',
    top: 100,
    left: 100,
    width: 200,
    height: 200,
    zPos: 0,
    depth: 0,
    fillStyle: '#cccccc',
    strokeStyle: '#999999',
    lineWidth: 1,
    alpha: 1
  }
}
